import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFoundPage() {
    return (
        <div data-testid="page-not-found" className="pt-20">
            {/* noindex tells Google to remove this URL from the index — protects against SEO spam
                backlinks that link to random URLs on our domain */}
            <Seo
                title="Page Not Found | Finance Wealth"
                description="The page you're looking for doesn't exist at Finance Wealth."
                robots="noindex, follow"
            />
            <section className="bg-[#F3F1EA]">
                <div className="container-prose py-32 md:py-40 text-center">
                    <div className="overline">Error 404</div>
                    <h1 className="mt-4 font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[1.02] text-[#1A362B] font-medium">
                        This page doesn't exist.
                    </h1>
                    <div className="divider-thin mx-auto my-8" />
                    <p className="text-lg text-[#1C1C1C]/70 leading-relaxed font-light max-w-xl mx-auto">
                        You may have followed an old or incorrect link. Head back to our home page
                        or explore our mortgage broking services.
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <Link to="/" data-testid="notfound-home" className="btn-primary">
                            Return home
                        </Link>
                        <Link to="/services" data-testid="notfound-services" className="btn-outline">
                            Explore services
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
